import { getRequest } from '../../services/api';
import type { ApiResponse } from '../../services/types';

import { CATEGORY_BANNER_CTA_TYPES } from './types';
import type { CategoryBanner } from './types';

// A CTA type added after this bundle has no handler here: drop the banner rather than show a dead tap.
const isSupportedCtaType = (ctaType: unknown): boolean =>
  (CATEGORY_BANNER_CTA_TYPES as readonly unknown[]).includes(ctaType);

export async function fetchCategoryBanners(lang: string): Promise<CategoryBanner[]> {
  const response = await getRequest<ApiResponse<CategoryBanner[], 'banners'>>('category-banners', { lang });
  return response.data.banners.filter((banner) => isSupportedCtaType(banner.ctaType));
}
